var _rect, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "#B9DCFF",
    stroke: "#B9DCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3744 35V18.9655H35L20 5L5 18.9655H8.62559V35H31.3744Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8733 29.7791C18.8733 27.3427 21.1744 27.3427 21.1744 24.9062C21.1744 22.4697 18.8733 22.4697 18.8733 20.0332",
    stroke: "url(#paint0_linear)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 29.7785C14.0002 28.1203 15.1508 28.1203 15.1508 26.4283C15.1508 24.7701 14.0002 24.7701 14.0002 23.0781",
    stroke: "url(#paint1_linear)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8967 29.7785C24.8967 28.1203 26.0473 28.1203 26.0473 26.4283C26.0473 24.7701 24.8967 24.7701 24.8967 23.0781",
    stroke: "url(#paint2_linear)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.1461,
    y1: 19.9993,
    x2: 14.5929,
    y2: 22.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA0029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.1366,
    y1: 23.0548,
    x2: 11.5269,
    y2: 24.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA0029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.0331,
    y1: 23.0548,
    x2: 22.4234,
    y2: 24.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA0029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermice);
export default __webpack_public_path__ + "static/media/Termice.34741620.svg";
export { ForwardRef as ReactComponent };